import { render, staticRenderFns } from "./EodbCommercialDetails.vue?vue&type=template&id=1839ff60&scoped=true&"
import script from "./EodbCommercialDetails.vue?vue&type=script&lang=js&"
export * from "./EodbCommercialDetails.vue?vue&type=script&lang=js&"
import style0 from "./EodbCommercialDetails.vue?vue&type=style&index=0&id=1839ff60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839ff60",
  null
  
)

export default component.exports